import { z } from "zod";
import type { TFunction } from "i18next";

export function createLoginSchema(t: TFunction<"auth">) {
  return z.object({
    email: z.email({ error: t("invalidEmail") }),
    password: z.string().min(1, t("passwordRequired")),
  });
}

export type LoginFormData = z.infer<ReturnType<typeof createLoginSchema>>;
